import * as React from 'react';
import * as InputMask from 'react-input-mask';
import { translate } from 'components/translate-hoc';

import { ITranslationProps } from 'types/translation';
import { IRedeemCodeFormat } from '@sitegen/common/types/redemption.types';

// styles
import './redeem-code-input.styles.less';

export class RedeemCodeInput extends React.Component<IRedeemCodeInputTranslateProps> {
    /* According to default configuration of plugin '*' equals to '[A-Za-z0-9]' regexp */
    public readonly GROUP_CHAR_PATTERN: string = '*';
    public readonly GROUP_DELIMITER: string = '-';
    public readonly GROUP_CHAR_PLACEHOLDER: string = 'X';
    public readonly GROUP_MASK_CHAR: string = '_';

    public codeMask: string = '';
    public codePlaceholder: string = '';

    constructor(props: IRedeemCodeInputTranslateProps) {
        super(props);
        this.codeMask = this.getRedeemCodeMask();
        this.codePlaceholder = this.getRedeemCodePlaceholder();
    }

    /** Code mask string looks like ***-***-*** */
    public getRedeemCodeMask(): string {
        const mask: string[] = [];
        const nChars: number = this.props.codeFormat.characters * this.props.codeFormat.groups;

        for (let i: number = 0; i < nChars; i++) {
            /* Insert delimiter symbol after each group */
            if (i !== 0 && i % this.props.codeFormat.characters === 0) {
                mask.push(this.GROUP_DELIMITER);
            }

            mask.push(this.GROUP_CHAR_PATTERN);
        }

        return mask.join('');
    }

    public getRedeemCodePlaceholder(): string {
        return this.getRedeemCodeMask().replace(/\*/g, this.GROUP_CHAR_PLACEHOLDER);
    }

    public handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        this.props.onRedeemCodeChange(e.target.value);
    };

    public getInputMask(): JSX.Element {
        return (
            // @ts-ignore
            <InputMask
                className="sitegen-redeem-code-input__input-with-mask"
                type="text"
                mask={this.codeMask}
                maskChar={this.GROUP_MASK_CHAR}
                placeholder={this.codePlaceholder}
                value={this.props.code}
                onChange={this.handleChange}
            />
        );
    }

    public render(): JSX.Element {
        return (
            <div className="sitegen-redeem-code-input">
                {this.getInputMask()}
            </div>
        );
    }
}

export interface IRedeemCodeInputProps {
    readonly code: string;
    readonly codeFormat: IRedeemCodeFormat;
    readonly onRedeemCodeChange: (code: string) => void;
}

export type IRedeemCodeInputTranslateProps = IRedeemCodeInputProps & ITranslationProps;

export default translate()(RedeemCodeInput) as React.ComponentClass<IRedeemCodeInputProps>;
